import React, { useEffect, useRef, useState } from 'react';
import {
  TabContainer,
  TabTitle,
  AddButton,
  AddText,
  ContentContainer,
  Content,
  AppointmentContainer,
  AppointmentDate,
  AppointmentName,
  DateBox,
  NameBox,
  IconPosition,
  SlotsTitle,
  SlotsContainer,
  SlotContainer,
  SlotName,
  SelectedSlotContainer,
  StyledInput,
  ContractName,
  CurrentSlotContainer,
  SelectedSlotForEditContainer,
  LoaderContainer,
} from './ClientDetails.styles';
import { ReactComponent as Calendar } from '../../../assets/icons/date.svg';
import { ReactComponent as Add } from '../../../assets/icons/btnAdd.svg';
import ModalComponent from '../../../components/Modal/ModalComponent';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import {
  selectClientAppointments,
  selectCreateAppointmentForClientPending,
  selectDeleteAppointmentPending,
  selectEditAppointmentPending,
  selectGetClientAppointmentsPending,
  selectGetVendorOccupiedPeriodPending,
} from '../../../store/slice/appointment/slice';
import { useDispatch, useSelector } from 'react-redux';
import { selectClientData, selectUserInfo } from '../../../store/slice/vendor/slice';
import {
  createAppointmentForClient,
  deleteAppointment,
  editAppointment,
  getClientAppointments,
  getVendorOccupiedPeriod,
} from '../../../store/slice/appointment/asyncThunks';
import { dateFormatterHalfMonth, timeFormatter } from '../../../utils/utils';

import { DAYS, SLOTS, SLOTS_TYPE } from '../../../utils/constants';
import { notifyErrorLeft, notifyInfo } from '../../../utils/notify';
import { Waveform } from '@uiball/loaders';
import { getVendorWorkingHours } from '../../../store/slice/vendor/asyncThunks';
import moment from 'moment';
import { getDay } from 'date-fns';
import { NoDataContainer } from '../ClientsPage.styles';
import { AppointmentModalContainer } from '../../CalendarPage/CalendarPage.styles';

const Appointments = ({ id }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState(new Date());
  const appointments = useSelector(selectClientAppointments);
  const getClientAppointmentsPending = useSelector(selectGetClientAppointmentsPending);

  const clientInfo = useSelector(selectClientData);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [selectedSlot, setSelectedSlot] = useState({});
  const [availableSlots, setSlots] = useState(SLOTS);
  const [show, setShow] = useState(false);
  const getVendorOccupiedPeriodPending = useSelector(selectGetVendorOccupiedPeriodPending);
  const { workingHours } = useSelector(selectUserInfo);
  const [filterDays, setFilterDays] = useState([]);
  const datePickerRef = useRef(null);

  const loading = useSelector(selectCreateAppointmentForClientPending);
  const editAppointmentPending = useSelector(selectEditAppointmentPending);
  const [appointmentStartSlotSelected, setAppointmentStartSlotSelected] = useState({});

  const [editAppointmentId, setEditAppointmentId] = useState(null);
  const deleteAppointmentPending = useSelector(selectDeleteAppointmentPending);

  const handleDeleteAppointment = id => {
    dispatch(deleteAppointment({ id }))
      .unwrap()
      .then(() => {
        closeEditModal();
        setEditAppointmentId(null);
        notifyInfo('Successfully deleted appointment');
      })
      .catch(err => {
        console.log(err);
        setEditAppointmentId(null);
        notifyErrorLeft(err.message);
      });
  };

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    dispatch(getClientAppointments({ id: id }));
    dispatch(getVendorWorkingHours())
      .unwrap()
      .then(data => {
        handleDaysToFilter(data.data.workingHours);
      })
      .catch(err => {
        console.log(err);
      });
  }, [dispatch, id]);

  const handleSlots = date => {
    const day = DAYS[date.getDay()];
    const open = workingHours[day.id + '_1_open'];
    const close = workingHours[day.id + '_1_close'];
    const openHours = moment(open, 'hh:mm a').toDate().getHours();
    const closeHours = moment(close, 'hh:mm a').toDate().getHours();
    const newSlots = [...SLOTS];

    return newSlots.filter(slot => slot.value >= openHours && slot.value < closeHours);
  };

  const handleDaysToFilter = data => {
    let filterDays = [];
    for (const day of DAYS) {
      if (!data[day.id + '_1_open']) {
        filterDays.push(day.number);
      }
    }
    setFilterDays(filterDays);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setName('');
    setDescription('');
    setLocation('');
    setAppointmentDate(new Date());
    setSelectedSlot({});
    setSlots(SLOTS);
    setIsModalOpen(false);
    setShow(false);
  };

  const handleCreateAppointment = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setHours(selectedSlot.value);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    setSelectedSlot(newFrom);
    let newTo = new Date(newFrom);
    newTo.setHours(newTo.getHours() + 1);
    const sendData = {
      id: clientInfo.id,
      body: {
        name,
        description,
        location,
        date: appointmentDate.getTime(),
        from: newFrom.getTime(),
        to: newTo.getTime(),
      },
    };
    dispatch(createAppointmentForClient(sendData))
      .unwrap()
      .then(() => {
        setName('');
        setDescription('');
        setLocation('');
        setAppointmentDate(new Date());
        setSelectedSlot({});
        setSlots(SLOTS);
        setIsModalOpen(false);
        setShow(false);
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };

  const handleSetDate = date => {
    const workingsSlots = handleSlots(date);
    setSelectedSlot({});
    setAppointmentDate(date);
    setShow(true);
    dispatch(getVendorOccupiedPeriod(date.getTime()))
      .unwrap()
      .then(data => {
        let newSlots = [...workingsSlots];
        for (const period of data.data) {
          if (period.type === SLOTS_TYPE.APPOINTMENT) {
            newSlots = newSlots.filter(slot => slot.value !== new Date(period.from).getHours().toString());
          } else {
            newSlots = newSlots.filter(
              slot => +slot.value < new Date(period.from).getHours() || +slot.value >= new Date(period.to).getHours(),
            );
          }
        }
        setSlots(newSlots);
        setShow(true);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const isFilterDay = date => {
    const day = getDay(date);
    if (filterDays.includes(day)) {
      return false;
    }
    return true;
  };

  const handleSelectSlot = slot => {
    if (selectedSlot.id === slot.id) {
      setSelectedSlot({});
    } else {
      setSelectedSlot(slot);
    }
  };

  const openEditModal = item => {
    const found = SLOTS.find(element => element.value === new Date(item.from).getHours().toString());
    setEditAppointmentId(item.id);
    setName(item.name);
    setDescription(item.description);
    setLocation(item.location);
    setAppointmentDate(item.from);
    handleSetDate(new Date(item.from));
    setAppointmentStartSlotSelected(found);
    setIsModalOpen(true);
    setShow(true);
  };
  const closeEditModal = () => {
    setName('');
    setDescription('');
    setLocation('');
    setAppointmentDate(new Date());
    setSelectedSlot({});
    setSlots(SLOTS);
    setIsModalOpen(false);
    setShow(false);
    setEditAppointmentId(null);
    setAppointmentStartSlotSelected({});
  };

  const handleEditAppointment = () => {
    let newFrom = new Date(appointmentDate);
    newFrom.setHours(selectedSlot.value ? selectedSlot.value : appointmentStartSlotSelected.value);
    newFrom.setSeconds(0);
    newFrom.setMinutes(0);
    let newTo = new Date(newFrom);
    newTo.setHours(newTo.getHours() + 1);
    const sendData = {
      id: editAppointmentId,
      body: {
        name,
        description,
        location,
        userId: clientInfo.id,
        date: appointmentDate.getTime(),
        from: newFrom.getTime(),
        to: newTo.getTime(),
      },
    };
    dispatch(editAppointment(sendData))
      .unwrap()
      .then(() => {
        closeEditModal();
        notifyInfo('Appointment edited successfully');
      })
      .catch(err => {
        console.log(err);
        notifyErrorLeft(err.message);
      });
  };
  return (
    <ContentContainer>
      <TabContainer>
        <TabTitle>Appointments</TabTitle>
        <AddButton onClick={openModal}>
          <Add />
          <AddText>New Appointment</AddText>
        </AddButton>
      </TabContainer>
      {!getClientAppointmentsPending ? (
        <Content className="vertical-scroll" $noGap>
          {appointments.data.length > 0 ? (
            <>
              {appointments.data.map(item => (
                <AppointmentContainer key={item.id} onClick={() => openEditModal(item)}>
                  <DateBox>
                    <AppointmentDate>{dateFormatterHalfMonth(item.date)}</AppointmentDate>
                  </DateBox>
                  <NameBox>
                    <AppointmentName>{item.name}</AppointmentName>
                    {item.from && <AppointmentName>{timeFormatter(item.from)}</AppointmentName>}
                    {item.location && <AppointmentName>{item.location}</AppointmentName>}
                  </NameBox>
                </AppointmentContainer>
              ))}
            </>
          ) : (
            <NoDataContainer>
              <ContractName>You don't have appointments with {clientInfo.firstName}.</ContractName>
            </NoDataContainer>
          )}
        </Content>
      ) : (
        <NoDataContainer>
          {/* <ContractName>You don't have to appointments with {clientInfo.firstName}.</ContractName> */}
          <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
        </NoDataContainer>
      )}

      <ModalComponent
        loading={loading || editAppointmentPending}
        isOpen={isModalOpen}
        onClose={editAppointmentId ? closeEditModal : closeModal}
        title={editAppointmentId ? 'Edit Appointment' : 'New Appointment'}
        rightButtonTitle={editAppointmentId && 'Save'}
        onCreate={editAppointmentId ? handleEditAppointment : handleCreateAppointment}
        createDisabled={
          loading ||
          editAppointmentPending ||
          !name ||
          (!Object.keys(selectedSlot).length && !Object.keys(appointmentStartSlotSelected).length) ||
          !appointmentDate ||
          deleteAppointmentPending
        }
        deleteIcon={editAppointmentId}
        appointment
        onClickDelete={() => {
          handleDeleteAppointment(editAppointmentId);
        }}>
        <AppointmentModalContainer>
          <StyledInput placeholder="Appointment type" onChange={n => setName(n.target.value)} value={name} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: 10 }}>
            <StyledInput placeholder="Client" value={clientInfo.firstName + ' ' + clientInfo.lastName} disabled />
            <StyledInput
              placeholder="Location"
              optional={true}
              onChange={n => setLocation(n.target.value)}
              value={location}
            />
            <StyledInput
              placeholder="Details"
              optional={true}
              value={description}
              onChange={n => setDescription(n.target.value)}
            />
            <div className="border-bottom">
              <DatePicker
                placeholderText="Date & Time"
                dateFormat="MMMM d, yyyy"
                className="date-picker"
                selected={appointmentDate}
                calendarClassName="scale"
                onChange={date => handleSetDate(date)}
                minDate={new Date()}
                filterDate={isFilterDay}
                ref={datePickerRef}
              />

              <IconPosition onClick={handleIconClick}>
                <Calendar />
              </IconPosition>
            </div>
            {editAppointmentId && !Object.keys(selectedSlot).length && (
              <CurrentSlotContainer>
                <SlotName>Appointment Start:</SlotName>
                <SelectedSlotForEditContainer>
                  <SlotName>{appointmentStartSlotSelected.title}</SlotName>
                </SelectedSlotForEditContainer>
              </CurrentSlotContainer>
            )}

            <>
              <SlotsTitle>Available Slots</SlotsTitle>
              {show ? (
                <>
                  {!getVendorOccupiedPeriodPending ? (
                    <>
                      <SlotsContainer>
                        {availableSlots.map(slot => (
                          <div key={slot.id}>
                            {slot.id === selectedSlot.id ? (
                              <SelectedSlotContainer key={slot.id} onClick={() => handleSelectSlot(slot)}>
                                <SlotName>{slot.title}</SlotName>
                              </SelectedSlotContainer>
                            ) : (
                              <SlotContainer onClick={() => handleSelectSlot(slot)}>
                                <SlotName>{slot.title}</SlotName>
                              </SlotContainer>
                            )}
                          </div>
                        ))}
                      </SlotsContainer>
                    </>
                  ) : (
                    <LoaderContainer>
                      <Waveform size={26} lineWeight={3.5} speed={1} color="black" />
                    </LoaderContainer>
                  )}
                </>
              ) : (
                <SlotName>Select date to see available time slots</SlotName>
              )}
            </>
          </div>
        </AppointmentModalContainer>
      </ModalComponent>
    </ContentContainer>
  );
};

export default Appointments;
